// src/pages/account/SecurityPage.jsx
import SecurityPanel from "./SecurityPanel";
export default function SecurityPage() {
  return <SecurityPanel />;
}